import { nToPx, themeVars } from '@tundr/theme';
import { style } from '@vanilla-extract/css';

export const formSectionContainerClass = style({
  background: themeVars.colors.neutrals.white,
  padding: themeVars.space.x8,
  borderRadius: themeVars.radius.md,
  marginBottom: themeVars.space.x10,
});

export const formSectionTitleClass = style({});

export const formSectionDescriptionClass = style({
  marginTop: themeVars.space.x2,
});

export const formSectionGridClass = style({
  display: 'grid',
  gap: themeVars.space.x4,
  margin: nToPx(themeVars.space.x4, 0, themeVars.space.x6, 0),
  alignItems: 'baseline',
  marginTop: themeVars.space.x10,
});
